import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TabService {
    tabIndex$ = new BehaviorSubject<number>(null);
}
